'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dHome$002dPage$0024 from "./presto.-Home-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002449 from "./presto.-Presto-Router$$anon$49.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$48() {
  this.bk5 = null;
  this.bjX = null;
  this.bjY = false;
  this.bk6 = null;
  this.bk7 = false;
  this.bka = null;
  this.bk3 = null;
  this.bk4 = false;
  this.bjZ = null;
  this.bk0 = false;
  this.bk1 = null;
  this.bk2 = false;
  this.bk8 = false;
  this.bk9 = false;
  this.bk5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bka = "HomePage";
}
export { $c_Lpresto_PrestoRouter$$anon$48 as $c_Lpresto_PrestoRouter$$anon$48 };
$p = $c_Lpresto_PrestoRouter$$anon$48.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$48;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$48() {
}
export { $h_Lpresto_PrestoRouter$$anon$48 as $h_Lpresto_PrestoRouter$$anon$48 };
$h_Lpresto_PrestoRouter$$anon$48.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bk5;
});
$p.M = (function() {
  if ((!this.bjY)) {
    this.bjX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bjY = true;
  }
  return this.bjX;
});
$p.O = (function() {
  if ((!this.bk7)) {
    this.bk6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bk7 = true;
  }
  return this.bk6;
});
$p.D = (function() {
  return this.bka;
});
$p.t = (function() {
  if ((!this.bk4)) {
    this.bk3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bk4 = true;
  }
  return this.bk3;
});
$p.N = (function() {
  if ((!this.bk0)) {
    this.bjZ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bk0 = true;
  }
  return this.bjZ;
});
$p.Q = (function() {
  if ((!this.bk2)) {
    this.bk1 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002449.$c_Lpresto_PrestoRouter$$anon$49();
    this.bk2 = true;
  }
  return this.bk1;
});
$p.v = (function() {
  if ((!this.bk9)) {
    this.bk8 = false;
    this.bk9 = true;
  }
  return this.bk8;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee384) => ((p) => \u03b4scrutinee384))($j_presto$002e$002dHome$002dPage$0024.$m_Lpresto_HomePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$48 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$48, "presto.PrestoRouter$$anon$48", ({
  On: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$48 as $d_Lpresto_PrestoRouter$$anon$48 };
//# sourceMappingURL=presto.-Presto-Router$$anon$48.js.map
